import Vue from 'vue'
import store from '../store'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const DEFAULT_TITLE = 'ClipLeap';

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: { title: DEFAULT_TITLE }
  },

  // STATIC
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/static/About.vue'),
    meta: { title: "About " + DEFAULT_TITLE }
  },
  {
    path: '/terms',
    name: 'terms',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/static/LegalTerms.vue'),
    meta: { title: "Terms of Service - " + DEFAULT_TITLE }
  },
  {
    path: '/privacy',
    name: 'privacy',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/static/LegalPrivacy.vue'),
    meta: { title: "Privacy Policy - " + DEFAULT_TITLE }
  },
  {
    path: '/cookies',
    name: 'cookies',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/static/LegalCookies.vue'),
    meta: { title: "Cookie Policy - " + DEFAULT_TITLE }
  },
  {
    path: '/rules',
    name: 'rules',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/static/LegalRules.vue'),
    meta: { title: "Rules - " + DEFAULT_TITLE }
  },
  // END of STATIC

  {
    path: '/video/:id/',
    name: 'video',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/Video.vue')
  },
  {
    path: '/clip/:id',
    name: 'chunk',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/Chunk.vue'),
    meta: { title: "Clip - " + DEFAULT_TITLE }
  },
  {
    path: '*',
    name: 'not-found',
    component: () => import('../views/NotFound.vue'),
    meta: { title: "Page not found - " + DEFAULT_TITLE }
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

router.afterEach((to, from) => {
  // console.log("route changed", from.params.id, ">", to.params.id);

  // set page title
  let page_title = to.meta.title || DEFAULT_TITLE
  if (to.name == "chunk") {
    const chunk = store.getters.chunkByID(to.params.id)
    const chunkTitle = chunk.title
    const videoTitle = store.getters.videoByID(chunk.video).title

    // TODO: fit titles for Google to max 70 chars... maybe
    // i.g.: Clip name... - Video... - ClipLeap

    page_title = `${chunkTitle} - ${videoTitle} - ${DEFAULT_TITLE}`
  }
  document.title = page_title;

  // Scroll to top if needed
  let shouldScroll = true;
  // Check if should not scroll
  // Do not scroll from-to same video
  if (from.name == 'chunk' && from.name == to.name) {
    let videoFrom = store.getters.chunkByID(from.params.id).video
    let videoTo = store.getters.chunkByID(to.params.id).video
    if (videoFrom == videoTo) {
      shouldScroll = false;
    }
  }

  // Scroll to top
  if (shouldScroll) {
    window.scrollTo(0,0)
  }
})

export default router
